import { css } from '@emotion/react';

export const containerStyles = css`
  display: flex;
  flex-direction: column;
  gap: var(--spacing-4);
  padding: var(--spacing-4);
  border-radius: var(--radius-lg);
  background: var(--surface-success);
`;

export const headerStyles = css`
  display: flex;
  flex-direction: column;
  gap: var(--spacing-2);
`;

export const chipsContainerStyles = css`
  display: flex;
  flex-wrap: wrap;
  gap: var(--spacing-4);

  & > button {
    background: transparent;
    border: none;
    padding: 0;
    margin: 0;
    cursor: pointer;
  }
`;

export const textAreaStyles = css`
  min-height: 62px;
`;

export const inputWrapperStyles = css`
  position: relative;
`;
